module.exports = __webpack_public_path__ + "static/img/product_img_05.5bffcde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_05.png
// module id = niFI
// module chunks = 0